// extracted by mini-css-extract-plugin
export default {"wrapper":"previewInfo_wrapper__6RIeD","innerWrapper":"previewInfo_innerWrapper__PTDhY","emptyAdImg":"previewInfo_emptyAdImg__pjHgb","tabWrapper":"previewInfo_tabWrapper__-m+SX"};